import React from 'react';
import { useTranslation } from 'react-i18next';
import circleBackgroundImage from './content-icon.svg';
import circleBackgroundImageDark from './content-icon-dark.svg';

interface IdentificationInfoContentProps {
  isDarkModeOn?: boolean;
  isDsa?: boolean;
}

const IdentificationInfoContent: React.FC<IdentificationInfoContentProps> = ({ isDarkModeOn, isDsa }) => {
  const { t } = useTranslation();

  return (
    <div className='grid-flex'>
      <div className='grid-item one-sixth grid-align-center'>
        <img
          src={isDarkModeOn ? circleBackgroundImageDark : circleBackgroundImage}
          alt='verification icon'
          height={66}
          width={64}
        />
      </div>
      <div className='grid-item four-fifth palm-padding-left-xl'>
        <p>{t(isDsa ? 'VerificationLandingPage.dsaText' : 'VerificationLandingPage.content')}</p>
      </div>
    </div>
  );
};

export default IdentificationInfoContent;
